export const JobTypes = {
	fulltime: 'Full-time',
	parttime: 'Part-time',
	contract: 'Contract',
	internship: 'Internship',
	commission: 'Commission',
};
